/**
 * Workarounds for DOCX import HTML inconsistencies.
 *
 * The DOCX import pipeline produces HTML that structurally differs from
 * TipTap's serialization. These normalizations bridge the gap so the
 * differ produces clean diffs.
 *
 * When the import pipeline is fixed to produce TipTap-compatible HTML,
 * this file can be deleted.
 */
import type * as cheerio from 'cheerio';
import type { CheerioAPI } from 'cheerio';
import type { Element } from 'domhandler';

/**
 * Strip HTML-default `colspan="1"` and `rowspan="1"` from table cells.
 *
 * DOCX omits these (they are implicit HTML defaults), while TipTap adds
 * them explicitly. Real merge/split values (≥2) are preserved.
 */
export const normalizeDefaultCellSpans = ($: CheerioAPI, $root: cheerio.Cheerio<Element>): void => {
  $root.find('td, th').each((_, cell) => {
    const $cell = $(cell);
    if ($cell.attr('colspan') === '1') $cell.removeAttr('colspan');
    if ($cell.attr('rowspan') === '1') $cell.removeAttr('rowspan');
  });
};
